import EventAttachment from './EventAttachments'

export default class Events {
    id: number
    eventStatusId: number
    eventName: string = ''
    eventDescription: string
    eventFrom: Date = new Date()
    eventTo: Date = new Date()
    bmweventNumberId: number
    webPublishDateFrom: Date = null
    webPublishDateTo: Date = null
    memberGenderTypeRequired: number
    memberBirthDateRequired: boolean
    maxMembersCount: number
    maxTeamsCount: number
    maxTeamSize: number
    minTeamSize: number
    teamLeaderRequired: boolean
    singleTeamPrice: number
    activ: boolean
    creatorUserId: number
    createDate: Date = new Date()
    attachment: EventAttachment = new EventAttachment()
    lastChangeDate: Date
    currentMembersCount: number
    availabilityId: number
    cancellationReason: string
    cancellationDate: Date
    cancellationUserId: number
    jahrgang: boolean
    [key: string]: any
}